<style lang="less" scoped>
.pages-layout {
  height: calc(100vh - 124px);
  position: relative;
  overflow-x: hidden;
  &__diallel {
    display: flex;
    height: calc(100vh - 155px);
    overflow: auto;

    .sidebar {
      width: 240px;
      background-color: #fff;
      border-radius: 8px;
      overflow: auto;
      margin-right: 12px;
      padding: 12px;
      box-sizing: border-box;
      position: relative;
    }
    .main {
      flex: 1;
      background-color: #fff;
      border-radius: 8px;
      padding: 12px;
      overflow: auto;
      box-sizing: border-box;
      overflow-x: hidden;
    }
  }
  .title {
    font-size: 16px;
    color: #222327;
    font-weight: 600;
    padding-bottom: 12px;
    position: sticky;
    z-index: 99;

    top: 0;
    background-color: #f5f7fd;
  }
  .handle {
    position: fixed;
    bottom: 0px;
    right: 0px;
    left: 0px;
    padding: 8px 32px;
    z-index: 9;
    display: flex;
    justify-content: flex-end;
    background-color: #fff;
    border-top: 1px solid #e4e5ea;
  }
}
.handle-spacing {
  height: calc(100vh - 152px - 22px);
}
</style>
<template>
  <div class="pages-layout" :class="[handle ? 'handle-spacing' : '']">
    <!-- <h3 class="title">{{ title }}</h3> -->
    <slot v-if="!diallel"></slot>
    <!-- 双列布局 -->
    <div v-if="diallel" class="pages-layout__diallel">
      <div class="sidebar">
        <slot name="sidebar" />
      </div>
      <div class="main">
        <slot name="main" />
      </div>
    </div>
    <div v-if="handle" class="handle">
      <slot name="handle" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  props: {
    /**
     * 双列布局
     */
    diallel: {
      type: Boolean,
      default: false,
    },

    /**
     * 双列布局
     */
    handle: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const route = useRoute();
    const title: any = ref("-");
    onMounted(() => {
      title.value = route.meta.title;
    });
    return {
      title,
    };
  },
});
</script>
